import { FC, useRef, useState } from "react"
import s from "@pages/fid_view/styles.module.css"
import classNames from "classnames"

interface PhotoGalleryProps {
  photos: string[]
  /** Контент под фото (название, кнопки) */
  children?: React.ReactNode
}

const PhotoGallery: FC<PhotoGalleryProps> = ({ photos, children }) => {
  const [idx, setIdx] = useState(0)
  const touchX = useRef<number | null>(null)
  const current = photos[idx]
  const total = photos.length

  const prev = () => setIdx(i => (i - 1 + total) % total)
  const next = () => setIdx(i => (i + 1) % total)

  const onTouchStart = (e: React.TouchEvent) => { touchX.current = e.touches[0].clientX }
  const onTouchEnd = (e: React.TouchEvent) => {
    if (touchX.current === null) return
    const dx = e.changedTouches[0].clientX - touchX.current
    if (dx < -40) next()
    else if (dx > 40) prev()
    touchX.current = null
  }

  return (
    <div className={s.gallery}>
      <div className={s.galleryStage} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
        {/* Размытая копия фото заполняет пустые места по бокам — само фото показываем целиком, без обрезки */}
        <div className={s.galleryBackdrop} style={{ backgroundImage: `url("${current}")` }} />
        <img className={s.galleryImg} src={current} alt="" draggable={false} />

        {total > 1 && (
          <>
            <button className={classNames(s.galleryArrow, s.galleryArrow_prev)} onClick={prev} aria-label="Предыдущее фото">‹</button>
            <button className={classNames(s.galleryArrow, s.galleryArrow_next)} onClick={next} aria-label="Следующее фото">›</button>
            <div className={s.galleryDots}>
              {photos.map((_, i) => (
                <button
                  key={i}
                  className={classNames(s.galleryDot, i === idx && s.galleryDot_active)}
                  onClick={() => setIdx(i)}
                  aria-label={`Фото ${i + 1}`}
                />
              ))}
            </div>
          </>
        )}
      </div>
      {children}
    </div>
  )
}

export default PhotoGallery
